import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Category } from '../../model/category';
import {
  Product,
} from '../../model/product';
import { Store } from '../../model/store';
import { IProductsApiService } from './products-api.interface';
import { ProductEditFormData } from '../../data/product-edit-form-data';
import { CreateProductRequestDto } from './dtos/commands/create-product.request.dto';
import { DeleteProductsRequestDto } from './dtos/commands/delete-products.request.dto';
import { UpdateProductRequestDto } from './dtos/commands/update-product.request.dto';
import { FindProductNamesQueryDto } from './dtos/queries/find-product-names.query.dto';
import { CreateProductResponseDto } from './dtos/commands/create-product.response.dto';
import { FindProductNamesResponseDto } from './dtos/queries/find-product-names.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ProductsMockApiService implements IProductsApiService {
  findProduct(productId: Product['id']): Promise<ProductEditFormData> {
    throw new Error('Method not implemented.');
  }
  createProduct(product: CreateProductRequestDto): Promise<CreateProductResponseDto> {
    throw new Error('Method not implemented.');
  }
  updateProduct(productId: number, product: UpdateProductRequestDto): Promise<any> {
    throw new Error('Method not implemented.');
  }
  deleteProducts(dto: DeleteProductsRequestDto): Promise<void> {
    throw new Error('Method not implemented.');
  }
  getStoreProductCategories(storeId: Store['id']): Observable<Category[]> {
    throw new Error('Method not implemented.');
  }
  findProductNames(options: FindProductNamesQueryDto): Promise<FindProductNamesResponseDto> {
    throw new Error('Method not implemented.');
  }
}
